import React from 'react'
import { compose } from 'recompose'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { openCanvasPreviewer } from 'store/preview/previewActions'
import {
  createElement,
  initializePaint,
  injectPaint,
  setStateChanged,
  clearStateChanged,
  selectElement,
} from './actions'
import { selectParentId, selectCanvasBluePrint, selectIsStateChanged, selectIsElementChange } from './selectors'

const mapStateToProps = (state) => ({
  parentId: selectParentId(state),
})

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({
    createElement,
    selectElement,
  }, dispatch)
)

export const withPaint = () => (
  compose(
    connect(mapStateToProps, mapDispatchToProps),
  )
)

export const withCanvas = () => (
  compose(
    connect(
      (state) => ({
        canvas: selectCanvasBluePrint(state),
        isStateChanged: selectIsStateChanged(state),
        isElementChange: selectIsElementChange(state),
      }),
      (dispatch) => (
        bindActionCreators({
          initializePaint,
          injectPaint,
          setStateChanged,
          clearStateChanged,
          openCanvasPreviewer,
        }, dispatch)
      ),
    ),
  )
)


// WEBPACK FOOTER //
// ./src/store/canvas/withPaint.js